import { API } from "aws-amplify";
import { useQuery } from "react-query";
import { IRegistry } from "../../../../routes/registries/models/Registry";

import { AxiosError } from "axios";
import { APIEndpoints, QueryKeys } from "../../config";

const makeApiRequest = (): Promise<IRegistry[]> => {
  const qParams = {};

  return API.get(APIEndpoints.private, "/api/v1/registries/", qParams);
};

export const useListRegistries = () => {
  return useQuery<IRegistry[], AxiosError>(
    QueryKeys.registries(),
    () => makeApiRequest(),
    {
      retry: 1,

      select: (data: IRegistry[]) => {
        data.sort((a, b) => {
          const aTitle = a.title.toLowerCase();
          const bTitle = b.title.toLowerCase();

          if (aTitle < bTitle) {
            return -1;
          }
          if (aTitle > bTitle) {
            return 1;
          }
          return 0;
        });

        return data;
      },
    }
  );
};
